// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 10355); hand-edits allowed (see docs/architecture.md)

/** `this.PAPA_WEAPONS` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_PAPA_WEAPONS(): any {
  return [
    [7, "low_gravity", "holy_hand_grenade", "baseball_bat", "teleport", "medikit", "gauss_rifle", "nuclear_bomb2"],
    [7, "uzi", "fast_walk", "molotov", "jet_pack", "ultra_scaner", "upg_teleport", "hearts_ace"],
    [7, "laser_pistol", "uzi", "shocker", "shotgun", "mortar", "plasma_rifle", "gauss_pistol2"],
    [7, "pistol", "add_time", "air_strike", "hunting_rifle", "plasma_rifle", "pulse_mine", "bozar16"],
    [7, "gauss_pistol", "laser_sight", "parachute", "blow_torch", "power_bat", "dl19", "super_hhg"],
    [7, "dynamite", "unfail_bazooka", "plasma_pistol", "grenade", "pulse_pistol", "mine_sheep", "gauss_pistol2"],
    [7, "mine", "girder", "sheep", "laser_rifle", "mine_strike", "girder_pack", "bozar24s"],
    [7, "old_woman", "battle_axe", "plasma_grenade", "dynamite_bunch", "minigun", "sniper_rifle", "laser_pistol2"]
  ];
}
